import React, { FC } from 'react';
import {
  TrajectorySectionCode,
  trajectorySectionLabelLookup,
} from 'src/config/api/models/Trajectory';
import { StyledTab } from './Atoms';
import { Tooltip } from '@material-ui/core';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

type TrajectorySectionMenuTabProps = {
  type: TrajectorySectionCode;
  handleChange: (newSectionCode: TrajectorySectionCode) => void;
  isDisabled?: boolean;
};

const a11yProps = (index: string) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

const TrajectorySectionMenuTab: FC<TrajectorySectionMenuTabProps> = ({
  type,
  handleChange,
  isDisabled,
}) => {
  const viewMode = useAppSelector((state) => state.trajectories.viewMode);
  return (
    <Tooltip
      title={'Geen inhoud beschikbaar'}
      placement="bottom-end"
      disableHoverListener={!isDisabled}
    >
      <span>
        <StyledTab
          label={trajectorySectionLabelLookup[type]}
          {...a11yProps(type)}
          onClick={() => handleChange(type)}
          disabled={isDisabled}
          style={{
            display: isDisabled && viewMode === 'read' ? 'none' : 'block',
          }}
        />
      </span>
    </Tooltip>
  );
};

export default TrajectorySectionMenuTab;
